const jobsAltTextI18nDe = {
  'altTextRepairerImage': 'Jobs in nachhaltiger Mode und Fashion Tech',
};

export default jobsAltTextI18nDe;
